var Mapa = function(el, datos, total, extra, callback) {
  var debug = false;
  var config = new Config(350, { top: 10, right: 10, bottom: 10, left: 10 });

  var margin = config.getMargin();
  var medidas = config.getMedidas();

  var gMargin = config.getGMargin();
  var gMedidas = config.getGMedidas();

  var estilos = config.getEstilos();

  var contenedor = null;
  var svg = null;
  var gGrafica = null;
  var gLeyendas = null;
  var gMapa = null;

  var principal = extra.principal;
  var secundario = extra.secundario;
  var mexico = extra.mexico;

  var coords = { x: 120, y: 120 };
  var txtValor = null;
  var txtMunicipio = null;

  var projection = d3.geo
    .mercator()
    .scale(5000)
    .center([-98.5, 24.5]);

  var path = d3.geo.path().projection(projection);

  function setup() {
    contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      el.data("visualizacion", true);
      contenedor.selectAll("svg").remove();
      svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr(
          "viewBox",
          "0 0 " +
            (medidas.ancho + margin.left + margin.right) +
            " " +
            (medidas.alto + margin.top + margin.bottom)
        );

      el.attr("data-setup", true);

      if (debug === true) {
        svg
          .append("rect")
          .attr("fill", "yellow")
          .attr("opacity", 0.5)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", medidas.ancho + margin.left + margin.right)
          .attr("height", medidas.alto + margin.top + margin.bottom);
      }

      svg = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (debug === true) {
        svg
          .attr("class", "svg")
          .append("rect")
          .attr("width", medidas.ancho + (margin.right - margin.left))
          .attr("height", medidas.alto)
          .attr("fill", "blue")
          .attr("opacity", 0.5);
      }

      gGrafica = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + gMargin.left + "," + gMargin.top + ")"
        );

      if (debug === true) {
        gGrafica
          .attr("class", "gGrafica")
          .append("rect")
          .attr("width", gMedidas.ancho)
          .attr("height", gMedidas.alto)
          .attr("fill", "red")
          .attr("opacity", 0.5);
      }

      gLeyendas = gGrafica.append("g");
      gMapa = gGrafica.append("g");

      _.each(datos.estados, function(e) {
        e.opcion = _.padStart(e.opcion, 2, "0");
        _.each(e.municipios, function(m) {
          m.opcion = _.padStart(m.opcion, 3, "0");
        });
      });
      main();
    }
  }

  function main() {
    setLeyendas();
    setMapa();
    funciones.generaTooltips(gGrafica.selectAll("path.transporte"));
    el.removeClass("espera");
    iniciar();
  }

  function revisaScroll() {
    if (debug === true) {
      iniciar();
      $(window).off("scroll", revisaScroll);
    } else {
      if (el.visible() === true) {
        iniciar();
        $(window).off("scroll", revisaScroll);
      }
    }
  }

  function iniciar() {
    iniciaMapa();
    callback(null, true);
  }

  function setLeyendas() {
    var estilosMapa = config.getMapa();
    var circulos = config.getCirculos();

    var objPrincipal =
      _.find(datos.estados, { opcion: principal.CVE_ENT }) || false;
    var objSecundario =
      _.find(datos.estados, { opcion: secundario.CVE_ENT }) || false;
    var valores = [];
    var pctPrincipal = objPrincipal === false ? 0 : objPrincipal.valor;
    valores.push(pctPrincipal);
    var pctSecundario = objSecundario === false ? 0 : objSecundario.valor;
    valores.push(pctSecundario);
    var pctResto = total - (pctPrincipal + pctSecundario);
    valores.push(pctResto);
    valores = funciones.getPorcentajes(valores, total);
    pctPrincipal = valores[0];
    pctSecundario = valores[1];
    pctResto = valores[2];
    var titulo = gLeyendas
      .append("text")
      .style(estilos.titulo)
      .attr("x", 0)
      .attr("y", margin.top);
    titulo
      .append("tspan")
      .attr("x", 0)
      .text(pctPrincipal + "% de los encuestados");

    var textoPrimario = "viven en ";
    textoPrimario += principal.CVE_ENT == "15" ? "el Estado de " : "";
    textoPrimario += principal.CVE_ENT == "09" ? "la " : "";
    textoPrimario += principal.nombre;
    titulo
      .append("tspan")
      .attr("x", 0)
      .attr("dy", "1.1em")
      .text("viven en " + textoPrimario);

    var textoSecundario = pctSecundario + "% de los encuestados viven en ";
    textoSecundario += secundario.CVE_ENT == "09" ? "la " : "el Estado de ";
    textoSecundario += secundario.nombre;
    gLeyendas
      .append("text")
      .attr("x", 0)
      .attr("y", gMedidas.alto - 18)
      .style(estilosMapa.leyenda)
      .text(textoSecundario);

    gLeyendas
      .append("text")
      .attr("x", 0)
      .attr("y", gMedidas.alto)
      .style(estilosMapa.leyenda)
      .text(
        pctResto + "% de los encuestados viven en otros estados de la República"
      );

    gLeyendas
      .append("circle")
      .attr("cx", coords.x)
      .attr("cy", coords.y)
      .attr("r", circulos.radio)
      .style(circulos.estiloCirculo);

    txtValor = gLeyendas
      .append("text")
      .attr("class", "valor")
      .attr("x", coords.x)
      .attr("y", coords.y)
      .style(circulos.estiloTexto)
      .text("0%");

    txtMunicipio = gLeyendas
      .append("text")
      .attr("x", coords.x)
      .attr("y", coords.y + circulos.radio + 15)
      .style(circulos.estiloSubTexto)
      .text("Desconocido");
  }

  function setMapa() {
    var estados =
      _.filter(datos.estados, function(e) {
        return e.opcion == principal.CVE_ENT || e.opcion == secundario.CVE_ENT;
      }) || false;

    var municipios = [];
    if (estados !== false) {
      _.each(estados, function(e) {
        _.each(e.municipios, function(m) {
          municipios.push({
            estado: e.opcion,
            municipio: m.opcion,
            valor: m.valor
          });
        });
      });
    }

    var valores = _.map(municipios, "valor");
    var pcts = funciones.getPorcentajes(valores, total);

    _.each(pcts, function(pct, i) {
      municipios[i].pct = pcts[i];
    });

    gMapa
      .selectAll("path.municipio")
      .data(topojson.feature(mexico, mexico.objects.mapa).features)
      .enter()
      .append("path")
      .attr("d", path)
      .attr("class", "municipio")
      .attr("fill", "#dedede")
      .style("stroke", "#ffffff")
      .style("opacity", 1)
      .each(function(d, i) {
        var obj =
          _.find(municipios, {
            estado: d.properties.CVE_ENT,
            municipio: d.properties.CVE_MUN
          }) || false;
        var valor = 0;
        var pct = 0;
        if (obj !== false) {
          valor = obj.valor;
          pct = obj.pct;
        }
        d.properties.valor = valor;
        d.properties.activo = false;
        d.properties.pct = pct;
      })
      .on("mouseover", function(d) {
        d3.select(this)
          .transition()
          .duration(200)
          .style("fill", "#c9faf6");
      })
      .on("mouseout", function(d) {
        d3.select(this)
          .transition()
          .duration(200)
          .style("fill", function(d) {
            if (d.properties.activo == true) {
              return "#14c1b4";
            } else {
              return d.properties.valor > 0 ? "#6df0e6" : "#dedede";
            }
          });
      })
      .on("click", actualizaMapa);
    var caja = gMapa.node().getBBox();
    var contenedorMapa = { width: gMedidas.ancho / 2, height: gMedidas.alto };
    var rAncho = contenedorMapa.width / caja.width;
    var rAlto = contenedorMapa.height / caja.height;
    var razon = _.min([rAncho, rAlto]);
    var nAncho = razon * caja.width;
    var offsetX = (gMedidas.ancho * 3) / 4 - nAncho / 2;
    gMapa.selectAll("path.municipio").style("stroke-width", 1 / razon + "px");
    gMapa.attr(
      "transform",
      "translate(" +
        offsetX +
        ",0)scale(" +
        razon +
        ")translate(" +
        -caja.x +
        "," +
        -caja.y +
        ")"
    );
  }

  function iniciaMapa() {
    var estados =
      _.filter(datos.estados, function(e) {
        return e.opcion == principal.CVE_ENT || e.opcion == secundario.CVE_ENT;
      }) || false;

    var municipios = [];
    if (estados !== false) {
      _.each(estados, function(e) {
        _.each(e.municipios, function(m) {
          municipios.push({
            estado: e.opcion,
            municipio: m.opcion,
            valor: m.valor
          });
        });
      });
    }

    var max = 0;
    var municipio = "000";
    var nombre = "Desconocido";
    var pct = 0;
    _.each(municipios, function(m) {
      if (m.valor > max) {
        max = m.valor;
        municipio = m.municipio;
      }
    });
    var objMunicipio = _.find(municipios, { municipio: municipio }) || false;

    if (objMunicipio !== false) {
      gMapa
        .selectAll("path.municipio")
        .each(function(d) {
          if (
            d.properties.CVE_ENT == objMunicipio.estado &&
            d.properties.CVE_MUN == objMunicipio.municipio
          ) {
            d.properties.activo = true;
            nombre = d.properties.NOMGEO;
            pct = d.properties.pct;
          }
        })
        .transition()
        .duration(800)
        .attr("fill", function(d) {
          var color = "#dedede";
          if (d.properties.valor > 0) {
            color = "#6df0e6";
          }
          if (
            d.properties.CVE_ENT == objMunicipio.estado &&
            d.properties.CVE_MUN == objMunicipio.municipio
          ) {
            color = "#14c1b4";
          }
          return color;
        });
      txtMunicipio
        .attr("opacity", 0)
        .transition()
        .duration(800)
        .text(nombre)
        .attr("opacity", 1);
      txtValor
        .attr("opacity", 0)
        .transition()
        .duration(800)
        .text(pct + "%")
        .attr("opacity", 1);
    }
  }

  function actualizaMapa(a) {
    var estado = a.properties.CVE_ENT;
    var municipio = a.properties.CVE_MUN;
    var nombre = a.properties.NOMGEO;
    var valor = a.properties.valor;
    var pct = a.properties.pct;
    pct = 0 < pct && pct < 1 ? "<1" : parseInt(pct);
    _.each(mexico.objects.mapa.geometries, function(d) {
      d.properties.activo =
        d.properties.CVE_MUN == municipio && d.properties.CVE_ENT == estado;
    });
    gMapa
      .selectAll("path.municipio")
      .transition()
      .duration(200)
      .style("fill", function(d) {
        if (d.properties.activo == true) {
          return "#14c1b4";
        } else {
          return d.properties.valor > 0 ? "#6df0e6" : "#dedede";
        }
      });
    txtMunicipio.text(nombre);
    txtValor.text(pct + "%");
  }

  setup();
};
